import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { NavLink } from 'react-router-dom'

import {
    CCloseButton,
    CSidebar,
    CSidebarBrand,
    CSidebarFooter,
    CSidebarHeader,
    CSidebarToggler,
} from '@coreui/react'

import { BackAppSidebarNav } from './BackAppSidebarNav'
import { useBackNav } from '../Back_nav'

const BackAppSidebar = () => {
    const dispatch = useDispatch()
    const unfoldable = useSelector((state) => state.sidebarUnfoldable)
    const sidebarShow = useSelector((state) => state.sidebarShow)

    const navigation = useBackNav()

    return (
        <CSidebar
            className="border-end"
            colorScheme="dark"
            position="fixed"
            unfoldable={unfoldable}
            visible={sidebarShow}
            onVisibleChange={(visible) =>
                dispatch({ type: 'set', sidebarShow: visible })
            }
        >
            <CSidebarHeader className="border-bottom">
                {/* ✅ CSidebarBrand = lien unique */}
                <CSidebarBrand
                    as={NavLink}
                    to="/"
                    className="d-flex align-items-center justify-content-center"
                >
                    <div
                        className="sidebar-logo-wrapper"
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            maxWidth: '180px',
                        }}
                    >
                        <img
                            src={`${process.env.PUBLIC_URL}/assets/images/logo.png`}
                            alt="Logo"
                            style={{
                                width: 50,
                                height: 50,
                                objectFit: 'cover',
                                borderRadius: '50%',
                                border: '2px solid #fff',
                                backgroundColor: '#fff',
                                marginRight: 10,
                            }}
                        />
                        <span
                            className="sidebar-logo-text"
                            style={{
                                fontSize: '1.3rem',
                                fontWeight: 'bold',
                                color: '#ffffff',
                                letterSpacing: '0.5px',
                                textTransform: 'uppercase',
                                whiteSpace: 'normal',
                                wordWrap: 'break-word',
                            }}
                        >
              TheSustain
            </span>
                    </div>
                </CSidebarBrand>

                <CCloseButton
                    className="d-lg-none"
                    dark
                    onClick={() => dispatch({ type: 'set', sidebarShow: false })}
                />
            </CSidebarHeader>

            {/* Slogan */}
            <p
                className="sidebar-slogan"
                style={{
                    fontSize: '0.9rem',
                    fontStyle: 'italic',
                    marginTop: '8px',
                    color: '#f4f3c4',
                    lineHeight: 1.3,
                    textAlign: 'center',
                    wordBreak: 'break-word',
                }}
            >
                Semer sur la terre pour récolter dans les cieux
            </p>

            <hr />

            {/* Navigation dynamique */}
            <BackAppSidebarNav items={navigation} />

            <CSidebarFooter className="border-top d-none d-lg-flex">
                <CSidebarToggler
                    onClick={() =>
                        dispatch({ type: 'set', sidebarUnfoldable: !unfoldable })
                    }
                />
            </CSidebarFooter>
        </CSidebar>
    )
}

export default React.memo(BackAppSidebar)
